export default __webpack_public_path__ + "static/media/parent_slide_student_four.c793b9ab.png";